import { mapAwardsToPlacement } from "../../helpers/transformRacePrizePool";
import types from "../actionTypes";

export const storeAwardPlacement = ({ id, awardHeaders }) => ({
  type: types.STORE_AWARD_PLACEMENT,
  payload: { id, awardData: mapAwardsToPlacement(awardHeaders) },
});
